// src/components/PublicFooter.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
    MAIN_ROUTE,
    HOW_IT_WORKS_ROUTE,
    ABOUT_ROUTE,
    FAQ_ROUTE,
    BLOG_ROUTE,
    NEWS_ROUTE,
    AMAZON_BSR_CALCULATOR_ROUTE,
    PRICING_ROUTE,
    CONTACT_ROUTE,
    TERMS_OF_USE_ROUTE,
    PRIVACY_POLICY_ROUTE,
    AFFILIATE_ROUTE,
    GET_AMAZON_BOOK_REVIEWS_ROUTE,
    FREE_AMAZON_BOOK_REVIEWS_ROUTE,
    ARC_BOOK_REVIEWS_AMAZON_ROUTE,
    PUBLIC_BOOK_LIBRARY_ROUTE,
    PUBLIC_PRODUCT_STORE_ROUTE,
    KDP_TOOLS_ROUTE,
    AI_TOOLS_FOR_KDP_ROUTE,
    FREE_TOOLS_FOR_AUTHORS_ROUTE,
} from "../utils/consts";

import {
    FaBookOpen,
    FaUsers,
    FaHome,
    FaPlayCircle,
    FaInfoCircle,
    FaQuestionCircle,
    FaPenNib,
    FaBullhorn,
    FaChartLine,
    FaTags,
    FaFileContract,
    FaUserShield,
    FaEnvelopeOpenText,
    FaDollarSign,
    FaYoutube,
    FaRedditAlien,
    FaFacebookSquare,
    FaStar,
    FaRobot,
} from "react-icons/fa";
import {FaBox} from "react-icons/fa6";
import {astroHref} from "../utils/astroLinks";

const footerStyle = {
    background: "linear-gradient(to right, #f8f9fa, #d4edda)",
    border: "1px solid #dee2e6",
    borderRadius: ".2rem",
};

const PublicFooter = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="mt-4">
            <Container fluid className="px-0">
                <div style={footerStyle} className="py-3 px-3">
                    <Row className="gy-3 text-muted small">
                        {/* Колонка 1 */}
                        <Col xs={12} md={6} lg={4}>
                            {/* Логотип */}
                            <div className="mb-2">
                                <a
                                    href={astroHref(MAIN_ROUTE)}
                                    className="d-inline-flex align-items-center text-decoration-none"
                                >
                                    <img
                                        src="https://virtalibry.com/Virtalibry_logo_sub_no_bg.png"
                                        alt="Virtalibry Logo"
                                        width="190"
                                        height="32"
                                        className="d-inline-block align-top"
                                    />
                                </a>
                            </div>

                            {/* Коронка + слоган */}
                            <div className="d-flex align-items-center mb-1" style={{ lineHeight: "1.1" }}>
                                <h6 className="mb-0 mt-0 text-success fw-semibold">
                                    Virtalibry — Tools and Resources for Amazon Authors and Sellers
                                </h6>
                            </div>

                            {/* Описание */}
                            <p className="mb-1" style={{ lineHeight: "1.3" }}>
                                A private membership platform designed for self-published authors and Amazon FBA sellers,
                                focused on reader engagement, product research, and building a sustainable long-term workflow.
                            </p>

                            <ul
                                className="list-unstyled mb-0 mt-0"
                                style={{ lineHeight: "1.3" }}
                            >
                                <li className="mt-2">
        <span className="d-block">
            © 2024-{year} Virtalibry. All rights reserved.
        </span>
                                    <span className="d-block">
            Crafted with care for authors, sellers, and readers — supporting creativity,
            discovery, and long-term growth through structured tools and insights.
        </span>
                                </li>
                            </ul>
                        </Col>


                        {/* Колонка 2 — Навигация по сервису */}
                        <Col xs={12} md={6} lg={2}>
                            <h6 className="text-success fw-semibold mb-2">Explore Virtalibry</h6>
                            <ul
                                className="list-unstyled mb-0 mt-0"
                                style={{ lineHeight: "1.1" }}
                            >
                                <li className="mb-1 d-flex align-items-center">
                                    <FaHome className="me-2 text-success" />
                                    <a href={astroHref(MAIN_ROUTE)} className="nav-seo-link-footer">
                                        Home
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaPlayCircle className="me-2 text-success" />
                                    <a href={astroHref(HOW_IT_WORKS_ROUTE)} className="nav-seo-link-footer">
                                        How It Works
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaInfoCircle className="me-2 text-success" />
                                    <a href={astroHref(ABOUT_ROUTE)} className="nav-seo-link-footer">
                                        About Virtalibry
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaQuestionCircle className="me-2 text-success" />
                                    <a href={astroHref(FAQ_ROUTE)} className="nav-seo-link-footer">
                                        Virtalibry FAQ
                                    </a>
                                </li>

                                {/*<li className="mb-1 d-flex align-items-center">*/}
                                {/*    <FaBullhorn className="me-2 text-success" />*/}
                                {/*    <NavLink to={NEWS_ROUTE} className="nav-seo-link-footer">*/}
                                {/*        News &amp; Updates*/}
                                {/*    </NavLink>*/}
                                {/*</li>*/}
                                <li className="mb-1 d-flex align-items-center">
                                    <FaDollarSign className="me-2 text-success" />
                                    <a href={astroHref(AFFILIATE_ROUTE)} className="nav-seo-link-footer">
                                        Affiliate Program
                                    </a>
                                </li>
                            </ul>
                        </Col>

                       {/* Колонка 3 — Для авторов и читателей */}
                        <Col xs={12} md={6} lg={2}>
                            <h6 className="text-success fw-semibold mb-2">
                                For Authors &amp; Readers
                            </h6>
                            <ul
                                className="list-unstyled mb-0 mt-0"
                                style={{ lineHeight: "1.1" }}
                            >
                                <li className="mb-1 d-flex align-items-center">
                                    <FaBox className="me-2 text-success" />
                                    <a href={astroHref(KDP_TOOLS_ROUTE)} className="nav-seo-link-footer">
                                        KDP Tools For Authors
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaChartLine className="me-2 text-success" />
                                    <a
                                        href={astroHref(AMAZON_BSR_CALCULATOR_ROUTE)}
                                        className="nav-seo-link-footer me-1"
                                    >
                                        Amazon BSR Calculator
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaRobot className="me-2 text-success" />
                                    <a href={astroHref(AI_TOOLS_FOR_KDP_ROUTE)} className="nav-seo-link-footer">
                                        AI Tools for KDP Boost
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaUsers className="me-2 text-success" />
                                    <a href={astroHref(FREE_TOOLS_FOR_AUTHORS_ROUTE)} className="nav-seo-link-footer">
                                        Free Tools for Authors
                                    </a>
                                </li>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaTags className="me-2 text-success" />
                                    <a href={PRICING_ROUTE} className="nav-seo-link-footer">
                                        Pricing &amp; Free Plan
                                    </a>
                                </li>

                            </ul>
                        </Col>

                        {/* Колонка 4 — SEO / Amazon Reviews */}
                        <Col xs={12} md={6} lg={2}>
                            <h6 className="text-success fw-semibold mb-2">Amazon Reviews How To</h6>

                            <ul
                                className="list-unstyled mb-0 mt-0"
                                style={{ lineHeight: "1.1" }}
                            >
                                {/* get amazon book reviews / get book reviews on amazon / get book reviews */}
                                <li className="mb-1 d-flex align-items-center">
                                    <FaStar className="me-2 text-success" />
                                    <a href={astroHref(GET_AMAZON_BOOK_REVIEWS_ROUTE)} className="nav-seo-link-footer">
                                        Amazon Book Reviews
                                    </a>
                                </li>

                                {/* get book reviews for free / getting book reviews */}
                                <li className="mb-1 d-flex align-items-center">
                                    <FaBookOpen className="me-2 text-success" />
                                    <a href={astroHref(FREE_AMAZON_BOOK_REVIEWS_ROUTE)} className="nav-seo-link-footer">
                                        Free Book Reviews
                                    </a>
                                </li>

                                {/* arc book reviews / arc reviews on amazon / arc in book publishing */}
                                <li className="mb-1 d-flex align-items-center">
                                    <FaPenNib className="me-2 text-success" />
                                    <a href={astroHref(ARC_BOOK_REVIEWS_AMAZON_ROUTE)} className="nav-seo-link-footer">
                                        ARC Book Reviews
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaBookOpen className="me-2 text-success" />
                                    <a href={astroHref(PUBLIC_BOOK_LIBRARY_ROUTE)} className="nav-seo-link-footer">
                                        ARC Book Library
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaBox className="me-2 text-success" />
                                    <a href={astroHref(PUBLIC_PRODUCT_STORE_ROUTE)} className="nav-seo-link-footer">
                                        Product Review Store
                                    </a>
                                </li>
                            </ul>
                        </Col>


                        {/* Колонка 5 — Легал, Контакт и Соцсети */}
                        <Col xs={12} md={6} lg={2}>
                            <h6 className="text-success fw-semibold mb-2">Trust &amp; Support</h6>

                            <ul className="list-unstyled mb-0 mt-0" style={{ lineHeight: "1.1" }}>
                                <li className="mb-1 d-flex align-items-center">
                                    <FaFileContract className="me-2 text-success" />
                                    <a href={astroHref(TERMS_OF_USE_ROUTE)} className="nav-seo-link-footer">
                                        Terms of Use
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaUserShield className="me-2 text-success" />
                                    <a href={astroHref(PRIVACY_POLICY_ROUTE)} className="nav-seo-link-footer">
                                        Privacy Policy
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaEnvelopeOpenText className="me-2 text-success" />
                                    <NavLink to={CONTACT_ROUTE} className="nav-seo-link-footer">
                                        Contact Support
                                    </NavLink>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaFacebookSquare className="me-2 text-primary" />
                                    <a
                                        href="https://www.facebook.com/groups/985103113724920"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="nav-seo-link-footer"
                                    >
                                        Facebook Group
                                    </a>
                                </li>

                                <li className="mb-1 d-flex align-items-center">
                                    <FaRedditAlien className="me-2" style={{ color: "#ff4500" }} />
                                    <a
                                        href="https://www.reddit.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="nav-seo-link-footer"
                                    >
                                        Reddit Discussion
                                    </a>
                                </li>

                                <li className="mb-0 d-flex align-items-center">
                                    <FaYoutube className="me-2 text-danger" />
                                    <a
                                        href="https://www.youtube.com/@virtalibry-qn9y"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="nav-seo-link-footer"
                                    >
                                        YouTube Channel
                                    </a>
                                </li>
                            </ul>
                        </Col>

                    </Row>
                </div>
            </Container>
        </footer>
    );
};

export default PublicFooter;
